import angular from 'angular';
import {
  loaderService,
  emDataService,
  emSharedModelService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
  actionIcon
} from 'app/components/global';
import editFunctionDialog from '../dialog.editFunctionDialog';
import itAsset from '../ITAsset';
import nonITAsset from '../nonITAsset';
import infrastructureOption from '../infrastructureOptions/infrastructureOption';
import internalSystemOption from '../internalSystemOptions/internalSystemOption';
import vendor from '../vendors/vendor';
import functionController from './function.controller';
import functionDirective from './function.directive';


export default angular.module('app.components.advisory.enterpriseModeling.function', [
  alerts,
  loaderService,
  emDataService,
  emSharedModelService,
  ssDialogService,
  confirmDialog,
  actionIcon,
  editFunctionDialog,
  infrastructureOption,
  internalSystemOption,
  vendor,
  itAsset,
  nonITAsset
])
  .directive('emFunction', functionDirective)
  .controller('FunctionController', functionController)
  .name;

console.log('app.components.advisory.enterpriseModeling.function created');
